type MapActivityBorderProps = {
    visible: boolean;
};

export function MapActivityBorder({ visible }: MapActivityBorderProps) {
    if (!visible) return null;
    return <div className="map-activity-border pointer-events-none absolute inset-0 z-20" aria-hidden="true" />;
}
